export default "/images/branding-urb.webp?31edc0600d369f14b6dbf864c278f4ad";